import type { AccordionData } from "@/design-system/Molecules/AccordionList/Accordion.types";
import React from "react";

const homeFaqPairs: [string, React.ReactNode][] = [
  [
    "Why Choose Defy Medical?",
    <>
      Defy Medical is an expert Men’s Health clinic.We take sexual health
      seriously, and we’ve put together a simple process to access treatment
      through DefyED.Our providers are experienced in treating ED along with low
      Testosterone, hair loss, weight gain, muscle loss, and more.In addition to
      our ED treatment, we offer a suite of health care services.{" "}
      <a
        href="https://www.defymedical.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#181a20] underline "
      >
        {" "}
        Learn more about us.
      </a>
    </>,
  ],
  [
    "How does DefyED’s treatment work?",
    <>
      It’s simple! Fill out our online questionnaire to provide your health
      history.Then we’ll give you recommendations on the best medications for
      you.Order your medications online and have them delivered directly to your
      door.
    </>,
  ],
  [
    "What Does DefyED Offer?",
    <>
      We offer access to common ED meds like Sildenafil(same ingredient as
      Viagra®).We also offer ED injections like Trimix for men seeking a faster
      and more powerful ED treatment.
    </>,
  ],
  [
    "What is the shipping process for my medication?",
    <>
      Once you place an order, Defy Medical sends it to a pharmacy within our
      pharmacy network.The pharmacy then ships your medication directly to your
      door.You’ll receive a tracking number when your order ships.
    </>,
  ],
  [
    "What is Trimix?",
    <>
      <p>
        Trimix is a penile injection that delivers potent ingredients directly
        to the penis for greater effect.Men report powerful erections that start
        within 15 minutes and last up to an hour.
      </p>
      <p>
        {" "}
        Trimix often provides results when oral medications like Sildenafil
        fail.If you’ve tried other medications that didn’t work, or you’d prefer
        a faster and more reliable ED solution, Trimix may be right for you.
      </p>
    </>,
  ],
  [
    "Can I combine ED medications?",
    <>
      <p>
        We do not recommend combining ED medications, especially Trimix and
        traditional oral medications.This can lead to a potential medical
        emergency called priapism, or an erection lasting longer than 4
        hours.Instead of combining therapies, work with Defy Medical to find the
        right medication and dosage for the results you want.
      </p>
    </>,
  ],
  [
    "How long does it take to see results from ED medications?",
    <>
      <p>
        Result times depend on the medication and the patient’s response.In
        general, oral medications typically take around 30 minutes to an hour,
        while ED injections trigger a response in 5–15 minutes on average.
      </p>
    </>,
  ],
  [
    "Does DefyED Take Insurance?",
    <>
      We don’t take insurance.Instead, we offer transparent, affordable prices
      with no insurance - related surprises.
    </>,
  ],
  [
    "How Does DefyED Choose Pharmacies for its Pharmacy Network?",
    <>
      We build our network by vetting pharmacies and ensuring that they meet
      high standards, follow USP and Good Manufacturing Practices, and utilize active ingredients.
    </>,
  ],
  [
    "Does DefyED Ship to My State?",
    <>
      DefyED’s Pharmacy Network can deliver to every state except California,
      Mississippi, and Idaho.Our network cannot ship oral medications to
      Minnesota but can ship Trimix injections.
    </>,
  ],
  [
    "How Long Does It Take for a Practitioner to Review My Information?",
    <>
      Our Care Team typically reviews health questionnaires within 24 business
      hours.
    </>,
  ],
  [
    "When will my order ship?",
    <>
      Orders ship out on weekdays.Orders placed after 5 PM on Friday will be
      processed and shipped the following week.You’ll receive tracking
      information from the pharmacy when your order ships.
    </>,
  ],
];

export const homeFaqData: AccordionData[] = homeFaqPairs.map(([question, answer]) => ({
    question,
    answer
}));
